// src/components/Navigation.js

import React, { useState } from 'react';
import { Link, NavLink } from 'react-router-dom';
import { Bars3Icon, XMarkIcon } from '@heroicons/react/24/outline';

export default function Navigation() {
  const [mobileOpen, setMobileOpen] = useState(false);

  // Define nav links and labels
  const links = [
    { to: '/', label: 'Home' },
    { to: '/vendors', label: 'Explore Vendors' },
    { to: '/become-a-vendor', label: 'Become a Vendor', isButton: true },
    { to: '/about', label: 'About' },
    { to: '/blog', label: 'Blog' },
    { to: '/contact', label: 'Contact' },
  ];

  return (
    <nav className="sticky top-0 z-50 bg-white/70 backdrop-blur-sm py-2 px-6 transition-colors">
      <div className="max-w-7xl mx-auto flex justify-between items-center">
        {/* Logo + Text */}
        <Link to="/" className="flex items-center space-x-2">
          <img src="/assets/logo.png" alt="My Event Mitra" className="h-10 w-auto" />
          <span className="text-2xl font-bold text-[#7C2D12]">My Event Mitra</span>
        </Link>

        {/* Desktop Links */}
        <div className="hidden md:flex space-x-8">
          {links.map(l =>
            l.isButton ? (
              <NavLink
                key={l.to}
                to={l.to}
                className={({ isActive }) =>
                  `px-4 py-2 rounded-lg font-medium transition-colors ${
                    isActive
                      ? 'bg-orange-600 text-white'
                      : 'bg-orange-500 text-white hover:bg-orange-600'
                  }`
                }
                aria-current={({ isActive }) => (isActive ? 'page' : undefined)}
              >
                {l.label}
              </NavLink>
            ) : (
              <NavLink
                key={l.to}
                to={l.to}
                className={({ isActive }) =>
                  `px-4 py-2 text-sm font-medium transition-colors ${
                    isActive
                      ? 'text-orange-600 underline'
                      : 'text-gray-700 hover:text-orange-600 hover:underline'
                  }`
                }
                aria-current={({ isActive }) => (isActive ? 'page' : undefined)}
              >
                {l.label}
              </NavLink>
            )
          )}
        </div>

        {/* Mobile menu button */}
        <button
          className="md:hidden p-2 text-gray-700 hover:text-orange-600"
          onClick={() => setMobileOpen(o => !o)}
          aria-label="Toggle menu"
          aria-expanded={mobileOpen}
        >
          {mobileOpen ? (
            <XMarkIcon className="h-6 w-6" />
          ) : (
            <Bars3Icon className="h-6 w-6" />
          )}
        </button>
      </div>

      {/* Mobile Menu */}
      {mobileOpen && (
        <div className="md:hidden bg-white shadow-md">
          {links.map(l => (
            <NavLink
              key={l.to}
              to={l.to}
              className={({ isActive }) =>
                `block px-6 py-3 border-t border-gray-100 transition-colors ${
                  l.isButton
                    ? isActive
                      ? 'bg-orange-600 text-white'
                      : 'bg-orange-500 text-white hover:bg-orange-600'
                    : isActive
                    ? 'text-orange-600'
                    : 'text-gray-700 hover:text-orange-600'
                }`
              }
              onClick={() => setMobileOpen(false)}
              aria-current={({ isActive }) => (isActive ? 'page' : undefined)}
            >
              {l.label}
            </NavLink>
          ))}
        </div>
      )}
    </nav>
);
}